import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../constants/config';
import { oauthLogin } from '../../actions/auth';

const GoogleLogin = props => {
    const { actions, history, isRequest } = props;
    const [isSignedIn, setIsSignedIn] = useState(false);
    let auth = null;
    const clientId = config && config.oauth && config.oauth.google && config.oauth.google.CLIENT_ID
        ? config.oauth.google.CLIENT_ID : '108681312374-o2vrc1uantn158qthd84beldk00sau9g.apps.googleusercontent.com';

    useEffect(() => {
        window.gapi && window.gapi.load("auth2", () => {
            window.gapi.auth2.init({
                client_id: clientId
            });
            auth = window.gapi.auth2.getAuthInstance();
            if (!auth) return;
            auth.isSignedIn.listen(onSignInSuccess);
            const element = document.getElementById("customBtn");
            auth.attachClickHandler(element, {});
        })

        return () => {
            setIsSignedIn(false);
            if (!auth) return;
            auth.disconnect();
            auth.signOut();
        }
    }, [window.gapi]);

    const onSignInSuccess = (isSignIn) => {
        if (isSignIn) {
            const cb = () => {
                setIsSignedIn(false);
                if (!auth) return;
                auth.disconnect();
                auth.signOut();
            }

            setIsSignedIn(true);
            const googleuser = auth.currentUser.get();
            const profile = googleuser.getBasicProfile();
            const params = {
                login: profile.getEmail(),
                provider: 1
            }
            actions.oauthLogin(params, history, cb);
        } else {
            if (isSignedIn) setIsSignedIn(false);
        }
    }

    return <div className="google-signin-btn">
        <div id="customBtn" className={`${isRequest && "disabled"}`}>
            <span className={`buttonText`}>
                <span className="icon"></span>{isSignedIn ? "Authenticating..." : "Sign in with Google"}
            </span>
        </div>
    </div>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ oauthLogin }, dispatch)
});

const mapStateToProps = state => ({ isRequest: state.auth.isRequest });

export default connect(mapStateToProps, mapDispatchToProps)(GoogleLogin);